import { To } from 'react-router-dom';

/**
 * Build a @see To object based on the provided string path.
 *
 * @param pathname A `string` that represents a route path.
 */
export const getFullPath = (pathname: string): To => {
  const { search, hash } = window.location;

  return { pathname, search, hash };
};
